import React, { useEffect, useMemo, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { US_STATES } from "../../../../../constants";

const useStyles = makeStyles(() => ({
    root: {
        margin: "14px 0px 2px",
        "& .MuiInputBase-root": {
            height: 53,
            borderRadius: "8px",
            "& .MuiSvgIcon-root": {
                width: 24,
                height: 24,
            },
        },
        "& .MuiInputLabel-root": {
            font: "normal normal normal 16px / 25px Poppins",
            color: "#B8B8B8",
            "&.Mui-focused, &.MuiInputLabel-shrink": {
                color: "#505050",
                backgroundColor: "#fff",
                paddingLeft: 2,
                paddingRight: 6,
                font: "normal normal normal 19px / 25px Poppins",
            },
        },
        "& .MuiOutlinedInput-root": {
            "& input": {
                font: "normal normal normal 16px / 25px Poppins",
                color: "#505050",
            },
            "& fieldset": {
                borderColor: "#B0B0B0",
            },
            "&:hover fieldset": {
                borderColor: "#B0B0B0",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#B0B0B0",
            },
        },
    },
    paperRoot: {
        font: "normal normal normal 16px / 25px Poppins !important",
        color: "#505050 !important",
    },
}));

function SelectState({ name, onSelect, label, value }) {
    const classes = useStyles();
    const [selectedState, setSelectedState] = useState(value);
    useEffect(() => {
        setSelectedState(value);
    }, [value]);
    const states = useMemo(() => Object.values(US_STATES), []);

    const handleChange = (_event, newValue) => {
        let val = newValue == null ? "" : newValue;
        onSelect({ target: { name: name, value: val } });
        setSelectedState(newValue);
    };

    return (
        <Autocomplete
            disablePortal
            id="select-state"
            name={name}
            options={states}
            value={selectedState}
            renderInput={(params) => <TextField {...params} label={label} />}
            onChange={handleChange}
            classes={{ root: classes.root }}
            componentsProps={{
                paper: {
                    // classes: {
                    //     root: classes.paperRoot,
                    // }
                    className: classes.paperRoot,
                },
            }}
        />
    );
}

export default SelectState;
